import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Button, Icon } from '@chakra-ui/react';
import React, { useLayoutEffect, useRef, useState } from 'react';
import FormattedText from '../rich-text-editor/FormattedText';

const COLLAPSED_HEIGHT_REM = 4;
const COLLAPSED_HEIGHT = `${COLLAPSED_HEIGHT_REM}rem`;

const NotePreview: React.FC<{ content: string }> = ({ content }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isLong, setIsLong] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      setIsLong(el.scrollHeight > rootFontSize * COLLAPSED_HEIGHT_REM);
    }
  }, [content]);

  if (!content || content.trim() === '') return null;

  return (
    <Box minWidth={0}>
      <Box
        ref={ref}
        maxHeight={isExpanded ? 'none' : COLLAPSED_HEIGHT}
        overflow={isExpanded ? 'visible' : 'hidden'}
      >
        <FormattedText
          content={content}
          fontSize="1rem"
          lineHeight="1.5"
          spacing="0.75rem"
        />
      </Box>
      {isLong && (
        <Button
          size="sm"
          variant="ghost"
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded(!isExpanded)}
          mt={1}
          fontSize="0.8rem"
          color="blue.600"
          _hover={{ bg: 'blue.50' }}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
          <Icon
            as={isExpanded ? ChevronUpIcon : ChevronDownIcon}
            ml={1}
            boxSize={3}
          />
        </Button>
      )}
    </Box>
  );
};

export default NotePreview;
